import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { plato_api_standards_path } from '@/modules/routes';
import QueryKeys from '@/utils/QueryKeys';
import { StandardsResponse } from './types';

interface UseStandardsParams {
  programId?: number | null;
  stateId: number | null;
}

export default function useStandards({ programId, stateId }: UseStandardsParams) {
  return useQuery({
    enabled: stateId !== null,
    queryFn: () => axios.get<StandardsResponse>(
      plato_api_standards_path(),
      { params: { fetch_all: true, program_id: programId, state_id: stateId } },
    ).then(res => res.data),
    queryKey: [QueryKeys.Standards, stateId, programId],
  });
}
